"use client";

import { useSyncExternalStore } from "react";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";

import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";

const subscribe = () => () => {};

export function ThemeToggle({ className }: { className?: string }) {
    const mounted = useSyncExternalStore(subscribe, () => true, () => false);
    const { resolvedTheme, setTheme } = useTheme();

    const isDark = resolvedTheme === "dark";
    const label = isDark ? "Activar modo claro" : "Activar modo oscuro";

    return (
        <Button
            type="button"
            variant="ghost"
            size="icon"
            className={cn("relative shrink-0", className)}
            aria-label={mounted ? label : "Cambiar tema"}
            aria-pressed={mounted ? isDark : undefined}
            title={mounted ? label : "Cambiar tema"}
            disabled={!mounted}
            onClick={() => setTheme(isDark ? "light" : "dark")}
        >
            {mounted && isDark ? <Sun aria-hidden /> : <Moon aria-hidden />}
        </Button>
    );
}
